import { Box, Typography } from '@mui/material'
import type { FC } from 'react'
import AboutLink from './AboutLink'
import Heading from './Heading'

const highlights = [
  'Classical Violin',
  'Irish Fiddle',
  'Musicology',
  'Orchestra',
  'Teaching',
  'Raleigh, NC'
]

const MainAbout: FC = () => {
  return (
    <section className='about-section about-intro'>
      <Heading heading='The Musician' />
      <Typography className='about-lead' component='p' sx={{ mb: 4 }}>
        A multi-faceted violinist bridging concert hall, classroom, and session.
      </Typography>
      <Box className='about-pills' component='ul' aria-label='Areas of expertise'>
        {highlights.map((label) => (
          <Box key={label} component='li' className='about-pill'>
            {label}
          </Box>
        ))}
      </Box>
      <Typography className='about-body' variant='body1' component='p'>
        Catherine Hall holds a bachelor&apos;s degree in classical violin performance from
        Appalachian State University, along with a master&apos;s degree and doctor of philosophy in
        musicology from Florida State University. She has nearly seventeen years of experience
        playing Irish traditional fiddle and was a member of two Irish traditional bands in
        Tallahassee, FL:{' '}
        <AboutLink
          link='https://open.spotify.com/album/4d0VtOmBliiuMcWdUbELtJ?si=IxmmliExQhigs9jFBWV2lw'
          title='The Ned Devines'
        />{' '}
        and{' '}
        <AboutLink
          link='https://sligoline.bandcamp.com/album/leaving-connolly-station'
          title='Sligo Line'
        />
        .
      </Typography>
      <Typography className='about-body' variant='body1' component='p'>
        For the past eight years, she has played with the Raleigh Civic Symphony and Chamber
        Orchestra at NCSU, and performs at weddings, church services, holiday celebrations, and
        events throughout the Raleigh area.
      </Typography>
    </section>
  )
}

export default MainAbout
